/**
 * Fetches the user data from the /account.json endpoint and extracts the customer tags.
 * This function assumes that even if /account.json returns HTML, it contains a
 * JavaScript object named 'userInfo' with the customer data.
 *
 * @returns {Promise<string[] | null>} A promise that resolves with an array of customer tags (strings),
 * or null if tags cannot be fetched or parsed.
 */
async function getCustomerTagsViaRest() {
    const accountJsonEndpoint = '/account.json';

    try {
        const response = await fetch(accountJsonEndpoint, {
            method: 'GET',
            headers: {
                'Accept': 'text/html, application/json'
            },
            credentials: 'include'
        });

        if (!response.ok) {
            let errorData = null;
            try {
                errorData = await response.json();
            } catch (e) {
            }

            console.error('Request to /account.json failed:', response.status, response.statusText, errorData);
            if (response.status === 401) {
                console.warn('Attempted to fetch /account.json but user is not logged in.');
            }
            return null;
        }

        const responseText = await response.text();

        const userInfoMatch = responseText.match(/var\s+userInfo\s*=\s*(\{[\s\S]*?\});/);

        if (userInfoMatch && userInfoMatch[1]) {
            try {
                const fixedJsonString = userInfoMatch[1].replace(/&quot;/g, '\\"');
                const userInfo = JSON.parse(fixedJsonString);
                if (userInfo && userInfo.tags) {
                    try {
                        const tagsString = userInfo.tags;
                        const tagsArray = JSON.parse(tagsString);
                        console.log('Customer tags successfully retrieved from userInfo object.');
                        return tagsArray;
                    } catch (e) {
                        return [];
                    }
                } else {
                    console.log('Customer tags not found in userInfo object.');
                    return [];
                }
            } catch (error) {
                console.error('Error parsing userInfo JSON:', error);
                return null;
            }
        } else {
            console.warn('userInfo object not found in /account.json response.');
            return null;
        }

    } catch (error) {
        console.error('Network error or failed processing fetching /account.json:', error);
        return null;
    }
}

async function checkAndApplyPlusDiscount(tags) {
    if (!tags.includes('World of Books +Plus Member')
        && !tags.includes('World of Books +Plus Member 14.99')
        && !tags.includes('World of Books +Plus Member 19.99')) {
        return;
    }
    try {
        const response = await fetch('/cart.json');
        if (!response.ok) {
            console.error('Error fetching cart data:', response.status);
            return;
        }
        const cartData = await response.json();
        const isPlusDiscountApplied = cartData.items.some(item =>
            item.discounts && item.discounts.some(discount => discount.title === 'PLUS')
        );

        if (!isPlusDiscountApplied) {
            try {
                await fetch('/discount/PLUS');
                console.log('Attempted to apply PLUS discount.');
            } catch (error) {
                console.error('Error applying PLUS discount:', error);
            }
        } else {
            console.log('PLUS discount already applied.');
        }
    } catch (error) {
        console.error('Error during discount check and application:', error);
    }
}